<template>
  <div class="login h100 base-view flex jc-center ai-center">
    <div class="login-view base-shadow bg-fff">
      <div class="login-tab flex ai-center jc-center font-16">
        <img v-if="info.collegeLogoUrl" class="logo" :src="info.collegeLogoUrl" alt="">
        {{ info.resultPageName }}
      </div>
      <div class="login-content custom-scrollbar pb-48">
        <div v-if="list.length" class="pl-24 pr-24">
          <div @click="onGrade(item)" class="lc-item" v-for="(item, index) in list" :key="`${index}_${item.collegeId}`">
            <img class="lc-logo" src="../../assets/icon_zy1.png" alt="">
            <div class="lc-content" v-if="item.resultType == 3">
              {{ item.collegeName + '录取信息' || '录取信息' }}
            </div>
            <div v-else class="lc-content">
              {{ item.specialtyName || '' }}{{ item.branchName || '' }}{{ item.resultType == 1 && item.hasPass == 1 ? (item.resultTitle ? item.resultTitle : '合格证') : '考试结果' }}
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div v-else class="pt-40">
          <FnEmpty message='没有发现数据'></FnEmpty>
        </div>
      </div>
      <div class="fixd-btn flex jc-center mt-16">
        <el-button round icon="el-icon-arrow-left" style="width:120px;" @click="onBack">
          返回
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as _localStorage from '@/utils/storage'
import FnEmpty from '@/components/fn-empty.vue'

export default {
  components: {FnEmpty},
  name: 'list',
  data() {
    return {
      info: null,
      list: [],
    }
  },
  async created() {
    this.info = _localStorage.getStorageSync('info')
    this.list = _localStorage.getStorageSync('resultList')
  },
  methods: {
    onBack() {
      this.$router.back()
    },
    onGrade(val) {
      _localStorage.setStorageSync('grade', val)
      this.$router.push('/result')
    },
  },
}
</script>
<style lang="scss" scoped>
.login {
  &-view {
    width: 640px;
    height: 700px;
    overflow: hidden;
    position: relative;
  }

  &-tab {
    border-bottom: 1px solid #E6E6E6;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    height: 70px !important;
    background-color: #409EFF;
    position: relative;

    &::after {
      width: 160px;
      height: 70px;
      content: '';
      position: absolute;
      top: 0;
      left: 70px;
      background-image: url('../../assets/head-l.png');
      background-repeat: no-repeat;
      background-size: 160px 100%;
    }

    &::before {
      width: 160px;
      height: 70px;
      content: '';
      position: absolute;
      top: 0;
      right: 161px;
      background-image: url('../../assets/head-r.png');
      background-repeat: no-repeat;
      background-size: 160px 100%;
    }

    .logo {
      height: 30px;
      width: 30px;
      border-radius: 8px;
      margin-right: 5px;
    }
  }

  &-content {
    height: calc(100% - 70px);
    overflow-y: auto;

    .lc-item {
      background: rgba(255, 255, 255, 0.39);
      border: 1px solid #D9D9D9;
      border-radius: 6px;
      padding: 12px 24px;
      margin: 16px 0;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .lc-logo {
      width: 26px;
      height: 26px;
      margin-right: 8px;
    }

    .lc-content {
      flex: 1;
      word-break: break-all;
    }

    .lc-icon {
      width: 25px;
    }
  }

  .fixd-btn {
    position: absolute;
    width: 100%;
    bottom: 10px;
    left: 0;
  }
}
</style>
